import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export interface DateFieldModel extends BaseFieldModel {
  defaultValue: string | undefined;
  placeholder: CultureTextModel[] | string;
  type: FieldType.Date;
}

export class DateField extends BaseField implements DateFieldModel {
  public defaultValue: string | undefined;
  public placeholder: CultureTextModel[] | string = '';
  public type: FieldType.Date = FieldType.Date;

  constructor(cultures: string[]) {
    super(FieldType.Date, cultures);

    this.placeholder = [];
    for (const culture of cultures) {
      this.placeholder.push({ culture, value: '' });
    }
  }
}
